// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__CWlz-","text":"SelectPayment_text__JfiRC","title":"SelectPayment_title__2GB6-","btn":"SelectPayment_btn__3Hb5k"};